export default __webpack_public_path__ + "static/media/Lena-28-web.c084cee6.jpg";